import { Component, Inject, Input, OnInit } from '@angular/core';
import { HomeController } from "@shared/src/controllers/home/home.controller";
import { RouteCardItemDto } from '@shared/src/dtos/route/RouteCardItemDto';


@Component({
    selector: 'shared-route-acquire-route-item',
    templateUrl: './shared.route.acquire.route.item.html',
    styleUrls: ['./shared.route.acquire.route.item.scss']
})
export class SharedRouteAcquireRouteItem implements OnInit {

    public useIonic: boolean = false;
    constructor(@Inject('HomeController') protected homeController: HomeController) {
        if (homeController.useIonic)
            this.useIonic = homeController.useIonic();
    }

    private _route: RouteCardItemDto;
    @Input()
    set route(value: RouteCardItemDto) {
        if (this._route === value)
            return;
        this._route = value;
    }
    get route(): RouteCardItemDto {
        return this._route;
    }

    @Input() selected: boolean;

    ngOnInit(): void {
    }
}
